interface PaperBallProps {
  size?: number;
  rotation?: number;
  className?: string;
  style?: React.CSSProperties;
}

const CRINKLE_SHAPES = [
  "polygon(52% 2%, 78% 6%, 96% 22%, 100% 48%, 88% 74%, 70% 95%, 42% 100%, 14% 92%, 2% 68%, 0% 38%, 12% 14%, 32% 2%)",
  "polygon(48% 0%, 80% 5%, 98% 28%, 95% 60%, 76% 90%, 48% 98%, 18% 88%, 3% 62%, 5% 32%, 20% 10%, 42% 0%)",
  "polygon(55% 3%, 82% 10%, 97% 35%, 92% 65%, 72% 93%, 44% 100%, 16% 90%, 4% 60%, 8% 28%, 25% 8%, 50% 2%)",
  "polygon(50% 0%, 76% 8%, 95% 30%, 98% 58%, 82% 85%, 52% 100%, 22% 94%, 5% 70%, 2% 40%, 14% 16%, 38% 2%)",
  "polygon(46% 2%, 74% 4%, 95% 24%, 100% 52%, 86% 78%, 62% 98%, 34% 100%, 10% 85%, 0% 55%, 8% 26%, 28% 6%)",
];

export function PaperBall({ size = 28, rotation = 0, className, style }: PaperBallProps) {
  const shapeIndex = Math.abs(Math.floor(rotation / 37)) % CRINKLE_SHAPES.length;
  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        flexShrink: 0,
        clipPath: CRINKLE_SHAPES[shapeIndex],
        background: `
          radial-gradient(circle at 33% 30%, #fefbf0 0%, #f0e2bc 55%, #d9c49a 100%)
        `,
        boxShadow: `1px 2px 5px rgba(0,0,0,0.28), inset 1px 1px 2px rgba(255,255,255,0.55)`,
        transform: `rotate(${rotation}deg)`,
        position: "relative",
        overflow: "hidden",
        ...style,
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: `
            repeating-linear-gradient(
              -52deg,
              transparent,
              transparent 4px,
              rgba(120,90,30,0.07) 4px,
              rgba(120,90,30,0.07) 5px
            )
          `,
        }}
      />
    </div>
  );
}
